"use client";
import React, { useState } from "react";
import styles from "./ForgotPassword.module.css";
import { isEmail } from "validator";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { showSuccessAlert, showErrorAlert } from "../../../utils/sweetAlertConfig";

const MAX_ATTEMPTS = 5;

export const ForgotPasswordForm = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [accountLocked, setAccountLocked] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    if (accountLocked) return;
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!isEmail(email)) {
      setError("Please enter a valid email");
      return;
    }
    setIsSending(true);
    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      setMessage("A password reset link has been sent to your email. Please check your inbox (and spam folder). And Login with new password");
      
      
      // Show success alert and redirect to login
      await showSuccessAlert(
        "A password reset link has been sent to your email. Please check your inbox (and spam folder).",
        "Reset Link Sent!"
      );
      
      setLoginAttempts(0);
      
      // Redirect to login using onBack
      setTimeout(() => {
        onBack();
      }, 5000);
      
    } catch (err) {
      setLoginAttempts((prev) => {
        const next = prev + 1;
        if (next >= MAX_ATTEMPTS) setAccountLocked(true);
        return next;
      });
      
      // Show error alert
      await showErrorAlert(
        err.message || "Failed to send reset email. Please try again.",
        "Reset Failed"
      );
    } finally {
      setIsSending(false);
    }
  };

  return (
    <main className={styles.formContainer}>
      <section className={styles.formContent}>
        <header className={styles.formHeader}>
          <div className={styles.iconContainer} onClick={onBack} style={{ cursor: 'pointer' }}>
            <img
              src="https://cdn.builder.io/api/v1/image/assets/e4c4028bee2e4c02982439ab63d2ae0b/d8ace4787438f852635a52c5d2e616526d3c1cfe?placeholderIfAbsent=true"
              alt="Forgot password icon"
              className={styles.icon}
            />
          </div>
          <h1 className={styles.title}>Forgot Password?</h1>
        </header>
        <p className={styles.description}>
          Lorem ipsum dolor sit amet consectetur. Lacus semper odio nibh montes fames eleifend. Ac habitant velit rutrum.
        </p>
      </section>
      <form className={styles.emailForm} onSubmit={handleSubmit}>
        <div className={styles.inputGroup}>
          <label htmlFor="email" className={styles.inputLabel}>
            Enter Your Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setError(""); setMessage(""); }}
            placeholder="example@example.com"
            className={styles.emailInput}
            required
            disabled={isSending || accountLocked}
          />
          {error && <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>{error}</div>}
        </div>
        {loginAttempts > 0 && !accountLocked && (
          <div style={{ textAlign: 'center', marginBottom: 8 }}>
            <small style={{ color: '#f59e42' }}>
              {MAX_ATTEMPTS - loginAttempts} attempt{MAX_ATTEMPTS - loginAttempts !== 1 ? 's' : ''} remaining
            </small>
          </div>
        )}
        {message && (
          <div style={{ color: '#22c55e', fontSize: '13px', marginBottom: 8 }}>{message}</div>
        )}
        <button type="submit" className={styles.submitButton} disabled={isSending || accountLocked}>
          <span className={styles.buttonText}>{isSending ? "Sending..." : accountLocked ? "Account Locked" : "Send Varification Link"}</span>
        </button>
      </form>
    </main>
  );
};
